const Trajectory = () =>
  import(
    /* webpackChunkName: "location-location-trajectori" */ '@/pages/location/location/trajectory.vue'
  )

export default {
  path: 'trajectory',
  meta: {
    label: 'trajectory',
    auth: 'trajectory'
  },
  component: {
    name: 'Trajectory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'GeoLocationTrajectory',
      path: '',
      meta: {
        label: 'report',
        auth: true
      },
      component: Trajectory
    }
  ]
}
